"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var reactstrap_1 = require("reactstrap");
var Types_1 = require("../../../../../Types");
var RAG;
(function (RAG) {
    RAG["Green"] = "Green";
    RAG["Amber"] = "Amber";
    RAG["Red"] = "Red";
})(RAG = exports.RAG || (exports.RAG = {}));
var HistoryRagIcon = /** @class */ (function (_super) {
    __extends(HistoryRagIcon, _super);
    function HistoryRagIcon(props) {
        var _this = _super.call(this, props) || this;
        _this.callOutId = Math.round(Math.random() * 9999999);
        _this.toggle = function () {
            _this.setState(function (prevState) { return ({ tooltipOpen: !prevState.tooltipOpen }); });
        };
        _this.state = {
            tooltipOpen: false
        };
        _this.tooltipTargetRef = React.createRef();
        return _this;
    }
    HistoryRagIcon.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("div", { ref: this.tooltipTargetRef }, this.props.isVisable && React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: this.props.icon, className: this.props.class })),
            this.props.messageText &&
                React.createElement(reactstrap_1.Tooltip, { placement: "bottom", isOpen: this.state.tooltipOpen, target: this.tooltipTargetRef, toggle: this.toggle }, this.props.messageText)));
    };
    HistoryRagIcon.getRagMultiple = function (packs) {
        return HistoryRagIcon.getRags(packs[0]);
    };
    HistoryRagIcon.getRagSingle = function (packInfo) {
        return HistoryRagIcon.getRags(packInfo);
    };
    HistoryRagIcon.getRags = function (packInfo) {
        return React.createElement("div", { style: { display: "flex", justifyContent: "space-evenly" } },
            React.createElement(HistoryRagIcon, { icon: free_solid_svg_icons_1.faCheckCircle, class: "text-" + Types_1.GetRagClass(packInfo.ragClass), isVisable: packInfo.ragClass === RAG.Green, 
                //<i className={`fa fa-check-circle green ${packInfo.ragClass === RAG.Green && "visible"}`} aria-hidden="true"></i>}
                messageText: undefined, messageType: undefined }),
            React.createElement(HistoryRagIcon
            //domElement={<i className={`fa fa-check-circle yellow ${packInfo.ragClass === RAG.Amber && packInfo.ragIcon === "fa-check-circle" && "visible"}`} aria-hidden="true"></i>}
            , { 
                //domElement={<i className={`fa fa-check-circle yellow ${packInfo.ragClass === RAG.Amber && packInfo.ragIcon === "fa-check-circle" && "visible"}`} aria-hidden="true"></i>}
                icon: free_solid_svg_icons_1.faCheckCircle, class: "text-" + Types_1.GetRagClass(packInfo.ragClass), isVisable: packInfo.ragClass === RAG.Amber && packInfo.ragIcon === "fa-check-circle", messageText: packInfo.ragClass === RAG.Amber && packInfo.ragIcon === "fa-check-circle" ? packInfo.warning || packInfo.information : undefined, messageType: RAG.Amber }),
            React.createElement(HistoryRagIcon
            //domElement={<i className={`fa fa-times-circle yellow ${packInfo.ragClass === RAG.Amber && packInfo.ragIcon === "fa-times-circle" && "visible"}`} aria-hidden="true"></i>}
            , { 
                //domElement={<i className={`fa fa-times-circle yellow ${packInfo.ragClass === RAG.Amber && packInfo.ragIcon === "fa-times-circle" && "visible"}`} aria-hidden="true"></i>}
                icon: free_solid_svg_icons_1.faTimesCircle, class: "text-" + Types_1.GetRagClass(packInfo.ragClass), isVisable: packInfo.ragClass === RAG.Amber && packInfo.ragIcon !== "fa-check-circle", messageText: packInfo.ragClass === RAG.Amber && packInfo.ragIcon !== "fa-check-circle" ? packInfo.warning || packInfo.information : undefined, messageType: RAG.Amber }),
            React.createElement(HistoryRagIcon
            //domElement={<i className={`fa fa-times-circle red ${packInfo.ragClass === RAG.Red && "visible"}`} aria-hidden="true"></i>}
            , { 
                //domElement={<i className={`fa fa-times-circle red ${packInfo.ragClass === RAG.Red && "visible"}`} aria-hidden="true"></i>}
                icon: free_solid_svg_icons_1.faTimesCircle, class: "text-" + Types_1.GetRagClass(packInfo.ragClass), isVisable: packInfo.ragClass === RAG.Red, messageText: packInfo.ragClass === RAG.Red ? packInfo.warning || packInfo.information : undefined, messageType: RAG.Red }));
    };
    return HistoryRagIcon;
}(React.Component));
exports.HistoryRagIcon = HistoryRagIcon;
//# sourceMappingURL=HistoryRagIcon.js.map